module.exports = __webpack_public_path__ + "static/img/apple-store-badge-es-UY.bbd6b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-es-UY.png
// module id = N2//
// module chunks = 1